export default "__VITE_ASSET__BO8R7AzJ__"